// @flow
import $ from 'jquery';
import JQueryView, {
  on,
  removeInvalidFeedback,
} from '../../../../common/JQueryView';

export default class FormView extends JQueryView {
  constructor() {
    super('.simple_form');

    $('.form-group-float').each((index, element) => {
      const control = $(element).find('.form-control');
      if (control.val().length !== 0) {
        control.addClass('form-control-active');
      } else {
        control.removeClass('form-control-active');
      }
    });

    this.render();
  }

  @on({ event: 'change', selector: '.form-control' })
  onChangeFormControl(event: any) {
    const target = $(event.target);
    if (target.val().length !== 0) {
      target.find('.form-control').addClass('form-control-active');
      target.removeClass('is-invalid');
      removeInvalidFeedback(target);
      target.removeClass('focus');
    }
  }

  @on({ event: 'blur input', selector: '.form-group-float, .form-control' })
  onBlurFormControl(event: any) {
    const target = $(event.target);
    if (target.hasClass('date-field1') && $('.show-calendar').is(':visible')) {
      target.addClass('form-control-active');
      target.addClass('focus');
    } else {
      if (target.val().length === 0) {
        target.removeClass('form-control-active');
      } else {
        target.addClass('form-control-active');
        target.removeClass('is-invalid');
        removeInvalidFeedback(target);
      }
    }
  }

  @on({ event: 'click', selector: '#back-button' })
  onClickBackButton(event: any) {
    event.preventDefault();
    $('#execute-sign-confirm').modal('hide');
    $('#execute-sign').modal('show');
  }

  render() {}
}
